export const FILTERS = {
  // FilterButton components
  FILTER_BUTTON_TOOLTIP: 'filterButtonTooltip',
  FILTER_BUTTON_ICON: 'filterButtonIcon',
  FILTER_BUTTON_TEXT: 'filterButtonText',
  FILTER_BUTTON_ICON_BUTTON: 'filterButtonIconButton',
  FILTER_BUTTON_BUTTON: 'filterButtonButton',
  FILTER_BUTTON_WRAPPER: 'filterButtonWrapper',

  // FilterWidget components
  FILTER_WIDGET: 'filterWidget',
  FILTER_SWITCH: 'filterSwitch',
  FILTER_SWITCH_WRAPPER: 'filterSwitchWrapper',
  FILTER_SWITCH_TEXT: 'filterSwitchText',
  LOGIC_DROPDOWN_BUTTON: 'logicDropdownButton',
  LOGIC_DROPDOWN_LABEL: 'logicDropdownLabel',
  LOGIC_DROPDOWN_ARROW: 'logicDropdownArrow',
  CLEAR_ALL_FILTERS_BUTTON: 'clearAllFiltersButton',

  // FilterCondition components
  FILTER_CONDITION: 'filterCondition',
  FIELD_DROPDOWN_BUTTON: 'fieldDropdownButton',
  FIELD_DROPDOWN_LABEL: 'fieldDropdownLabel',
  FIELD_DROPDOWN_ARROW: 'fieldDropdownArrow',
  OPERATOR_DROPDOWN_BUTTON: 'operatorDropdownButton',
  OPERATOR_DROPDOWN_LABEL: 'operatorDropdownLabel',
  OPERATOR_DROPDOWN_ARROW: 'operatorDropdownArrow',
  FILTER_OPTION_DROPDOWN_BUTTON: 'filterOptionDropdownButton',
  FILTER_OPTION_DROPDOWN_LABEL: 'filterOptionDropdownLabel',
  FILTER_OPTION_DROPDOWN_ARROW: 'filterOptionDropdownArrow',
  FILTER_OPTION_DROPDOWN_SEARCH_INPUT: 'filterOptionDropdownSearchInput',
  FILTER_OPTION_DROPDOWN_SEARCH_ICON: 'filterOptionDropdownSearchIcon',
  FILTER_OPTION_DROPDOWN_MENU_ITEM: 'filterOptionDropdownMenuItem',
  FILTER_OPTION_DROPDOWN_INFO_ICON: 'filterOptionDropdownInfoIcon',
  CONDITION_CHECKBOX: 'conditionCheckbox',
  CONDITION_CHECKBOX_INPUT: 'conditionCheckboxInput',
  CONDITION_CHECKBOX_LABEL: 'conditionCheckboxLabel',
  DELETE_CONDITION_BUTTON: 'deleteConditionButton',
  DELETE_CONDITION_ICON: 'deleteConditionIcon',
  FILTER_ACTION_BUTTONS_WRAPPER: 'filterActionButtonsWrapper',
  FILTER_CONDITION_CONTAINER: 'filterConditionContainer',
  EMPTY_FIELD_BUTTON: 'emptyFieldButton',
  DATE_INPUT_FIELD: 'dateInputField',
  FLOAT_INPUT_FIELD: 'floatInputField',
  FLOAT_INPUT_TOOLTIP: 'floatInputTooltip',
  FLOAT_INPUT_ADORNMENT: 'floatInputAdornment',
  ID_INPUT_FIELD: 'idInputField',

  // Input components
  CALENDAR_INPUT: 'calendarInput',
  CALENDAR_DROPDOWN_BUTTON: 'calendarDropdownButton',
  CALENDAR_LABEL: 'calendarLabel',
  CALENDAR_ARROW: 'calendarArrow',
  CALENDAR_DROPDOWN_SEARCH_INPUT: 'calendarDropdownSearchInput',
  CALENDAR_DROPDOWN_SEARCH_ICON: 'calendarDropdownSearchIcon',
  CALENDAR_DROPDOWN_MENU_ITEM: 'calendarDropdownMenuItem',
  CALENDAR_DROPDOWN_NO_RESULTS: 'calendarDropdownNoResults',
  CALENDAR_INPUT_CONTAINER: 'calendarInputContainer',
  CALENDAR_INPUT_ICON: 'calendarInputIcon',

  STATUS_INPUT: 'statusInput',
  STATUS_DROPDOWN_BUTTON: 'statusDropdownButton',
  STATUS_LABEL: 'statusLabel',
  STATUS_ARROW: 'statusArrow',

  CUSTOM_CODE_INPUT: 'customCodeInput',
  CUSTOM_CODE_DROPDOWN_BUTTON: 'customCodeDropdownButton',
  CUSTOM_CODE_LABEL: 'customCodeLabel',
  CUSTOM_CODE_ARROW: 'customCodeArrow',
  CUSTOM_CODE_DROPDOWN_SEARCH_INPUT: 'customCodeDropdownSearchInput',
  CUSTOM_CODE_DROPDOWN_SEARCH_ICON: 'customCodeDropdownSearchIcon',
  CUSTOM_CODE_DROPDOWN_MENU_ITEM: 'customCodeDropdownMenuItem',
  CUSTOM_CODE_DROPDOWN_TAG: 'customCodeDropdownTag',

  CUSTOM_CODE_MULTI_INPUT: 'customCodeMultiInput',
  CUSTOM_CODE_MULTI_DROPDOWN_BUTTON: 'customCodeMultiDropdownButton',
  CUSTOM_CODE_MULTI_LABEL: 'customCodeMultiLabel',
  CUSTOM_CODE_MULTI_ARROW: 'customCodeMultiArrow',
  CUSTOM_CODE_MULTI_DROPDOWN_SEARCH_INPUT: 'customCodeMultiDropdownSearchInput',
  CUSTOM_CODE_MULTI_DROPDOWN_SEARCH_ICON: 'customCodeMultiDropdownSearchIcon',
  CUSTOM_CODE_MULTI_DROPDOWN_MENU_ITEM: 'customCodeMultiDropdownMenuItem',
  CUSTOM_CODE_MULTI_DROPDOWN_TAG: 'customCodeMultiDropdownTag',
  CUSTOM_CODE_MULTI_DROPDOWN_SWITCH: 'customCodeMultiDropdownSwitch',
  CUSTOM_CODE_MULTI_DROPDOWN_NO_RESULTS: 'customCodeMultiDropdownNoResults',
  CUSTOM_CODE_MULTI_INPUT_CONTAINER: 'customCodeMultiInputContainer',

  CONSTRAINT_INPUT: 'constraintInput',
  CONSTRAINT_DROPDOWN_BUTTON: 'constraintDropdownButton',
  CONSTRAINT_LABEL: 'constraintLabel',
  CONSTRAINT_ARROW: 'constraintArrow',
  CONSTRAINT_INPUT_CONTAINER: 'constraintInputContainer',
  CONSTRAINT_SEARCH_WRAPPER: 'constraint-search-wrapper',
  CONSTRAINT_SEARCH_ICON: 'constraint-search-icon',

  CONSTRAINT_MULTI_INPUT: 'constraintMultiInput',
  CONSTRAINT_MULTI_DROPDOWN_BUTTON: 'constraintMultiDropdownButton',
  CONSTRAINT_MULTI_LABEL: 'constraintMultiLabel',
  CONSTRAINT_MULTI_ARROW: 'constraintMultiArrow',
  CONSTRAINT_MULTI_DROPDOWN_SEARCH_INPUT: 'constraintMultiDropdownSearchInput',
  CONSTRAINT_MULTI_DROPDOWN_SEARCH_ICON: 'constraintMultiDropdownSearchIcon',
  CONSTRAINT_MULTI_DROPDOWN_MENU_ITEM: 'constraintMultiDropdownMenuItem',
  CONSTRAINT_MULTI_DROPDOWN_SWITCH: 'constraintMultiDropdownSwitch',
  CONSTRAINT_MULTI_DROPDOWN_NO_RESULTS: 'constraintMultiDropdownNoResults',
  CONSTRAINT_MULTI_INPUT_CONTAINER: 'constraintMultiInputContainer',

  USERS_INPUT: 'usersInput',
  USERS_DROPDOWN_BUTTON: 'usersDropdownButton',
  USERS_LABEL: 'usersLabel',
  USERS_ARROW: 'usersArrow',

  USERS_MULTI_INPUT: 'usersMultiInput',
  USERS_MULTI_DROPDOWN_BUTTON: 'usersMultiDropdownButton',
  USERS_MULTI_LABEL: 'usersMultiLabel',
  USERS_MULTI_ARROW: 'usersMultiArrow',

  VARIANCE_CODES_INPUT: 'varianceCodesInput',
  VARIANCE_CODES_DROPDOWN_BUTTON: 'varianceCodesDropdownButton',
  VARIANCE_CODES_LABEL: 'varianceCodesLabel',
  VARIANCE_CODES_ARROW: 'varianceCodesArrow',

  VARIANCE_CODES_MULTI_INPUT: 'varianceCodesMultiInput',
  VARIANCE_CODES_MULTI_DROPDOWN_BUTTON: 'varianceCodesMultiDropdownButton',
  VARIANCE_CODES_MULTI_LABEL: 'varianceCodesMultiLabel',
  VARIANCE_CODES_MULTI_ARROW: 'varianceCodesMultiArrow',

  FLOAT_PATH_INPUT: 'floatPathInput',
  FLOAT_PATH_DROPDOWN_BUTTON: 'floatPathDropdownButton',
  FLOAT_PATH_LABEL: 'floatPathLabel',
  FLOAT_PATH_ARROW: 'floatPathArrow',

  FLOAT_PATH_MULTI_INPUT: 'floatPathMultiInput',
  FLOAT_PATH_MULTI_DROPDOWN_BUTTON: 'floatPathMultiDropdownButton',
  FLOAT_PATH_MULTI_LABEL: 'floatPathMultiLabel',
  FLOAT_PATH_MULTI_ARROW: 'floatPathMultiArrow',

  RESOURCE_EQUIPMENT_INPUT: 'resourceEquipmentInput',
  RESOURCE_EQUIPMENT_DROPDOWN_BUTTON: 'resourceEquipmentDropdownButton',
  RESOURCE_EQUIPMENT_LABEL: 'resourceEquipmentLabel',
  RESOURCE_EQUIPMENT_ARROW: 'resourceEquipmentArrow',

  RESOURCE_EQUIPMENT_MULTI_INPUT: 'resourceEquipmentMultiInput',
  RESOURCE_EQUIPMENT_MULTI_DROPDOWN_BUTTON: 'resourceEquipmentMultiDropdownButton',
  RESOURCE_EQUIPMENT_MULTI_LABEL: 'resourceEquipmentMultiLabel',
  RESOURCE_EQUIPMENT_MULTI_ARROW: 'resourceEquipmentMultiArrow',

  RESOURCE_LABOR_INPUT: 'resourceLaborInput',
  RESOURCE_LABOR_DROPDOWN_BUTTON: 'resourceLaborDropdownButton',
  RESOURCE_LABOR_LABEL: 'resourceLaborLabel',
  RESOURCE_LABOR_ARROW: 'resourceLaborArrow',

  RESOURCE_LABOR_MULTI_INPUT: 'resourceLaborMultiInput',
  RESOURCE_LABOR_MULTI_DROPDOWN_BUTTON: 'resourceLaborMultiDropdownButton',
  RESOURCE_LABOR_MULTI_LABEL: 'resourceLaborMultiLabel',
  RESOURCE_LABOR_MULTI_ARROW: 'resourceLaborMultiArrow',

  RELATIONSHIP_MULTI_INPUT: 'relationshipMultiInput',
  RELATIONSHIP_MULTI_DROPDOWN_BUTTON: 'relationshipMultiDropdownButton',
  RELATIONSHIP_MULTI_LABEL: 'relationshipMultiLabel',
  RELATIONSHIP_MULTI_ARROW: 'relationshipMultiArrow',

  STATUS_MULTI_INPUT: 'statusMultiInput',
  STATUS_MULTI_DROPDOWN_BUTTON: 'statusMultiDropdownButton',
  STATUS_MULTI_LABEL: 'statusMultiLabel',
  STATUS_MULTI_ARROW: 'statusMultiArrow',

  // Text and numeric inputs
  NAME_INPUT: 'nameInput',
  ID_INPUT: 'idInput',
  FLOAT_INPUT: 'floatInput',
  PERCENTAGE_INPUT: 'percentageInput',
  DURATION_DAYS_INPUT: 'durationDaysInput',
  LAG_INPUT: 'lagInput',
  DATE_INPUT: 'dateInput',

  // SavedFiltersDropdown components
  SAVED_FILTERS_DROPDOWN: 'savedFiltersDropdown',
  SAVED_FILTERS_SELECT: 'savedFiltersSelect',
  SAVED_FILTERS_SEARCH_INPUT: 'savedFiltersSearchInput',
  SAVED_FILTERS_SEARCH_FIELD: 'savedFiltersSearchField',
  SAVED_FILTERS_HEADER: 'savedFiltersHeader',
  SAVED_FILTER_OPTION: 'savedFilterOption',
  SAVED_FILTER_CHECKMARK: 'savedFilterCheckmark',
  SAVED_FILTER_CONTEXT_MENU: 'savedFilterContextMenu',
  SAVED_FILTER_MORE_BUTTON: 'savedFilterMoreButton',
  SAVED_FILTER_CONTEXT_ICON: 'savedFilterContextIcon',
  SAVED_FILTER_TICK_ICON: 'savedFilterTickIcon',
  CREATE_NEW_FILTER_BUTTON: 'createNewFilterButton',
  SAVE_FILTER_BUTTON: 'saveFilterButton',
  SAVE_CHANGES_BUTTON: 'saveChangesButton',
  SAVE_FILTER_ICON: 'saveFilterIcon',
  SAVE_FILTER_TEXT: 'saveFilterText',

  // FieldDropdown components
  FIELD_DROPDOWN: 'fieldDropdown',
  FIELD_DROPDOWN_SEARCH_INPUT: 'fieldDropdownSearchInput',
  FIELD_DROPDOWN_SEARCH_WRAPPER: 'fieldDropdownSearchWrapper',
  FIELD_DROPDOWN_SEARCH_ICON: 'fieldDropdownSearchIcon',
  FIELD_DROPDOWN_ELEMENTS_WRAPPER: 'fieldDropdownElementsWrapper',
  FIELD_DROPDOWN_ELEMENTS: 'fieldDropdownElements',
  FIELD_DROPDOWN_ELEMENT: 'fieldDropdownElement',
  FIELD_DROPDOWN_ICON: 'fieldDropdownIcon',
  FIELD_DROPDOWN_MENU_LABEL: 'fieldDropdownMenuLabel',
  FIELD_DROPDOWN_HELP_ICON: 'fieldDropdownHelpIcon',
  FIELD_DROPDOWN_RIGHT_CHEVRON: 'fieldDropdownRightChevron',
  FIELD_DROPDOWN_SEPARATOR: 'fieldDropdownSeparator',
  FIELD_DROPDOWN_RECENT_WRAPPERS: 'fieldDropdownRecentWrappers',
  FIELD_DROPDOWN_RECENT_LABEL: 'fieldDropdownRecentLabel',

  // FilterNameInput components
  FILTER_NAME_INPUT: 'filterNameInput',
  FILTER_NAME_INPUT_CONTAINER: 'filterNameInputContainer',
  FILTER_NAME_TEXT_INPUT: 'filterNameTextInput',
  FILTER_NAME_COMBO_SEARCH: 'filterNameComboSearch',
  FILTER_NAME_COMBO_SEARCH_POPUP: 'filterNameComboSearchPopup',

  // Multi-input tag components
  MULTI_INPUT_TAGS: 'multiInputTags',
  MULTI_INPUT_TAG: 'multiInputTag',
  MULTI_INPUT_LABEL: 'multiInputLabel',
  MULTI_INPUT_ARROW: 'multiInputArrow',

  // Navigation components
  NAVIGATE_FILTERED_ELEMENTS: 'navigateFilteredElements',

  // Filter dialogs
  FILTER_SAVE_DIALOG: 'filterSaveDialog',
  FILTER_RENAME_DIALOG: 'filterRenameDialog',
  FILTER_DELETE_DIALOG: 'filterDeleteDialog',
  FILTERS_HOME_POPOVER: 'filtersHomePopover',
  FILTERS_HOME_CREATE_NEW_FILTER_BUTTON: 'filtersHomeCreateNewFilterButton',
  FILTERS_HOME_OR_TEXT: 'filtersHomeOrText',
  FILTER_WIDGET_POPOVER: 'filterWidgetPopover',
  FILTER_WIDGET_SWITCH_BUTTON: 'filterWidgetSwitchButton',
  FILTER_WIDGET_COMBINATOR_BUTTON: 'filterWidgetCombinatorButton',
  FILTER_WIDGET_CLEAR_ALL_FILTERS_BUTTON: 'filterWidgetClearAllFiltersButton',
  FLOAT_PATH_DROPDOWN_POPOVER: 'floatPathDropdownPopover',
  FLOAT_PATH_DROPDOWN_SEARCH_INPUT: 'floatPathDropdownSearchInput',
  FLOAT_PATH_DROPDOWN_SEARCH_ICON: 'floatPathDropdownSearchIcon',
  FLOAT_PATH_DROPDOWN_MENU_ITEM: 'floatPathDropdownMenuItem',
  FLOAT_PATH_DROPDOWN_TICK_ICON: 'floatPathDropdownTickIcon',
  FLOAT_PATH_INPUT_CONTAINER: 'floatPathInputContainer',
  FLOAT_PATH_INPUT_PLACEHOLDER: 'floatPathInputPlaceholder',
  FLOAT_PATH_INPUT_ARROW_ICON: 'floatPathInputArrowIcon',
  FLOAT_PATH_MULTI_DROPDOWN_POPOVER: 'floatPathMultiDropdownPopover',
  FLOAT_PATH_MULTI_DROPDOWN_SEARCH_INPUT: 'floatPathMultiDropdownSearchInput',
  FLOAT_PATH_MULTI_DROPDOWN_SEARCH_ICON: 'floatPathMultiDropdownSearchIcon',
  FLOAT_PATH_MULTI_DROPDOWN_MENU_ITEM: 'floatPathMultiDropdownMenuItem',
  FLOAT_PATH_MULTI_DROPDOWN_SWITCH_BUTTON: 'floatPathMultiDropdownSwitchButton',
  FLOAT_PATH_MULTI_DROPDOWN_NO_RESULTS: 'floatPathMultiDropdownNoResults',
  FLOAT_PATH_MULTI_INPUT_CONTAINER: 'floatPathMultiInputContainer',
  FLOAT_PATH_MULTI_INPUT_PLACEHOLDER: 'floatPathMultiInputPlaceholder',
  FLOAT_PATH_MULTI_INPUT_ARROW_ICON: 'floatPathMultiInputArrowIcon',
  FLOAT_PATH_MULTI_INPUT_TAGS_CONTAINER: 'floatPathMultiInputTagsContainer',
  LOGIC_DROPDOWN_POPOVER: 'logicDropdownPopover',
  LOGIC_DROPDOWN_MENU_ITEM: 'logicDropdownMenuItem',
  LOGIC_DROPDOWN_SELECTED_LABEL: 'logicDropdownSelectedLabel',
  LOGIC_DROPDOWN_TICK_ICON: 'logicDropdownTickIcon',
  RELATIONSHIP_MULTI_DROPDOWN_POPOVER: 'relationshipMultiDropdownPopover',
  RELATIONSHIP_MULTI_DROPDOWN_SEARCH_INPUT: 'relationshipMultiDropdownSearchInput',
  RELATIONSHIP_MULTI_DROPDOWN_SEARCH_ICON: 'relationshipMultiDropdownSearchIcon',
  RELATIONSHIP_MULTI_DROPDOWN_MENU_ITEM: 'relationshipMultiDropdownMenuItem',
  RELATIONSHIP_MULTI_DROPDOWN_TAG: 'relationshipMultiDropdownTag',
  RELATIONSHIP_MULTI_DROPDOWN_SWITCH_BUTTON: 'relationshipMultiDropdownSwitchButton',
  RELATIONSHIP_MULTI_DROPDOWN_NO_RESULTS: 'relationshipMultiDropdownNoResults',
  RESOURCE_EQUIPMENT_DROPDOWN_POPOVER: 'resourceEquipmentDropdownPopover',
  RESOURCE_EQUIPMENT_DROPDOWN_SEARCH_INPUT: 'resourceEquipmentDropdownSearchInput',
  RESOURCE_EQUIPMENT_DROPDOWN_MENU_ITEM: 'resourceEquipmentDropdownMenuItem',
  RESOURCE_EQUIPMENT_DROPDOWN_TAG: 'resourceEquipmentDropdownTag',
  RESOURCE_EQUIPMENT_DROPDOWN_TICK_ICON: 'resourceEquipmentDropdownTickIcon',
  RESOURCE_EQUIPMENT_INPUT_CONTAINER: 'resourceEquipmentInputContainer',
  RESOURCE_EQUIPMENT_INPUT_PLACEHOLDER: 'resourceEquipmentInputPlaceholder',
  RESOURCE_EQUIPMENT_INPUT_LABEL: 'resourceEquipmentInputLabel',
  RESOURCE_EQUIPMENT_INPUT_ARROW_ICON: 'resourceEquipmentInputArrowIcon',
  RESOURCE_EQUIPMENT_MULTI_DROPDOWN_POPOVER: 'resourceEquipmentMultiDropdownPopover',
  RESOURCE_EQUIPMENT_MULTI_DROPDOWN_SEARCH_INPUT: 'resourceEquipmentMultiDropdownSearchInput',
  RESOURCE_EQUIPMENT_MULTI_DROPDOWN_SEARCH_ICON: 'resourceEquipmentMultiDropdownSearchIcon',
  RESOURCE_EQUIPMENT_MULTI_DROPDOWN_MENU_ITEM: 'resourceEquipmentMultiDropdownMenuItem',
  RESOURCE_EQUIPMENT_MULTI_DROPDOWN_TAG: 'resourceEquipmentMultiDropdownTag',
  RESOURCE_EQUIPMENT_MULTI_DROPDOWN_SWITCH_BUTTON: 'resourceEquipmentMultiDropdownSwitchButton',
  RESOURCE_EQUIPMENT_MULTI_DROPDOWN_NO_RESULTS: 'resourceEquipmentMultiDropdownNoResults',
  RESOURCE_EQUIPMENT_MULTI_INPUT_CONTAINER: 'resourceEquipmentMultiInputContainer',
  RESOURCE_EQUIPMENT_MULTI_INPUT_PLACEHOLDER: 'resourceEquipmentMultiInputPlaceholder',
  RESOURCE_EQUIPMENT_MULTI_INPUT_TAGS_CONTAINER: 'resourceEquipmentMultiInputTagsContainer',
  RESOURCE_EQUIPMENT_MULTI_INPUT_TAG: 'resourceEquipmentMultiInputTag',
  RESOURCE_EQUIPMENT_MULTI_INPUT_ARROW_ICON: 'resourceEquipmentMultiInputArrowIcon',
  RESOURCE_LABOR_DROPDOWN_POPOVER: 'resourceLaborDropdownPopover',
  RESOURCE_LABOR_DROPDOWN_SEARCH_INPUT: 'resourceLaborDropdownSearchInput',
  RESOURCE_LABOR_DROPDOWN_MENU_ITEM: 'resourceLaborDropdownMenuItem',
  RESOURCE_LABOR_DROPDOWN_TAG: 'resourceLaborDropdownTag',
  RESOURCE_LABOR_DROPDOWN_TICK_ICON: 'resourceLaborDropdownTickIcon',
  RESOURCE_LABOR_INPUT_CONTAINER: 'resourceLaborInputContainer',
  RESOURCE_LABOR_INPUT_PLACEHOLDER: 'resourceLaborInputPlaceholder',
  RESOURCE_LABOR_INPUT_LABEL: 'resourceLaborInputLabel',
  RESOURCE_LABOR_INPUT_ARROW_ICON: 'resourceLaborInputArrowIcon',
  RESOURCE_LABOR_MULTI_DROPDOWN_POPOVER: 'resourceLaborMultiDropdownPopover',
  RESOURCE_LABOR_MULTI_DROPDOWN_SEARCH_INPUT: 'resourceLaborMultiDropdownSearchInput',
  RESOURCE_LABOR_MULTI_DROPDOWN_SEARCH_ICON: 'resourceLaborMultiDropdownSearchIcon',
  RESOURCE_LABOR_MULTI_DROPDOWN_MENU_ITEM: 'resourceLaborMultiDropdownMenuItem',
  RESOURCE_LABOR_MULTI_DROPDOWN_TAG: 'resourceLaborMultiDropdownTag',
  RESOURCE_LABOR_MULTI_DROPDOWN_SWITCH_BUTTON: 'resourceLaborMultiDropdownSwitchButton',
  RESOURCE_LABOR_MULTI_DROPDOWN_NO_RESULTS: 'resourceLaborMultiDropdownNoResults',
  RESOURCE_LABOR_MULTI_INPUT_CONTAINER: 'resourceLaborMultiInputContainer',
  RESOURCE_LABOR_MULTI_INPUT_PLACEHOLDER: 'resourceLaborMultiInputPlaceholder',
  RESOURCE_LABOR_MULTI_INPUT_TAGS_CONTAINER: 'resourceLaborMultiInputTagsContainer',
  RESOURCE_LABOR_MULTI_INPUT_TAG: 'resourceLaborMultiInputTag',
  RESOURCE_LABOR_MULTI_INPUT_ARROW_ICON: 'resourceLaborMultiInputArrowIcon',
  SAVED_FILTERS_DROPDOWN_SELECT: 'savedFiltersDropdownSelect',
  SAVED_FILTERS_DROPDOWN_SEARCH_INPUT: 'savedFiltersDropdownSearchInput',
  SAVED_FILTERS_DROPDOWN_MENU_ITEM: 'savedFiltersDropdownMenuItem',
  SAVED_FILTERS_DROPDOWN_CONTEXT_MENU_CONTAINER: 'savedFiltersDropdownContextMenuContainer',
  SAVED_FILTERS_DROPDOWN_CONTEXT_MENU_ICON: 'savedFiltersDropdownContextMenuIcon',
  SAVED_FILTERS_DROPDOWN_CHECKMARK: 'savedFiltersDropdownCheckmark',
  SAVED_FILTERS_DROPDOWN_TICK_ICON: 'savedFiltersDropdownTickIcon',
  SAVED_FILTERS_DROPDOWN_NO_FILTERS_MESSAGE: 'savedFiltersDropdownNoFiltersMessage',
  SAVED_FILTERS_DROPDOWN_SAVE_CHANGES_BUTTON: 'savedFiltersDropdownSaveChangesButton',
  STATUS_DROPDOWN_POPOVER: 'statusDropdownPopover',
  STATUS_DROPDOWN_SEARCH_INPUT: 'statusDropdownSearchInput',
  STATUS_DROPDOWN_SEARCH_ICON: 'statusDropdownSearchIcon',
  STATUS_DROPDOWN_MENU_ITEM: 'statusDropdownMenuItem',
  STATUS_DROPDOWN_TAG: 'statusDropdownTag',
  STATUS_DROPDOWN_TICK_ICON: 'statusDropdownTickIcon',
  STATUS_MULTI_DROPDOWN_POPOVER: 'statusMultiDropdownPopover',
  STATUS_MULTI_DROPDOWN_SEARCH_INPUT: 'statusMultiDropdownSearchInput',
  STATUS_MULTI_DROPDOWN_SEARCH_ICON: 'statusMultiDropdownSearchIcon',
  STATUS_MULTI_DROPDOWN_MENU_ITEM: 'statusMultiDropdownMenuItem',
  STATUS_MULTI_DROPDOWN_TAG: 'statusMultiDropdownTag',
  STATUS_MULTI_DROPDOWN_SWITCH_BUTTON: 'statusMultiDropdownSwitchButton',
  STATUS_MULTI_DROPDOWN_NO_RESULTS: 'statusMultiDropdownNoResults',
  STATUS_MULTI_INPUT_CONTAINER: 'statusMultiInputContainer',
  STATUS_MULTI_INPUT_PLACEHOLDER: 'statusMultiInputPlaceholder',
  STATUS_MULTI_INPUT_TAGS_CONTAINER: 'statusMultiInputTagsContainer',
  STATUS_MULTI_INPUT_TAG: 'statusMultiInputTag',
  STATUS_MULTI_INPUT_ARROW_ICON: 'statusMultiInputArrowIcon',
  WATCHLIST_INPUT: 'watchlistInput',
  WATCHLIST_LABEL: 'watchlistLabel',
  WATCHLIST_ARROW: 'watchlistArrow',
  WATCHLIST_DROPDOWN_POPOVER: 'watchlistDropdownPopover',
  WATCHLIST_DROPDOWN_MENU_ITEM: 'watchlistDropdownMenuItem',
  WATCHLIST_DROPDOWN_TAG: 'watchlistDropdownTag',
  NOTES_INPUT: 'notesInput',
  NOTES_LABEL: 'notesLabel',
  NOTES_ARROW: 'notesArrow',
  NOTES_DROPDOWN_POPOVER: 'notesDropdownPopover',
  NOTES_DROPDOWN_MENU_ITEM: 'notesDropdownMenuItem',
  NOTES_DROPDOWN_TAG: 'notesDropdownTag',
  USERS_DROPDOWN_POPOVER: 'usersDropdownPopover',
  USERS_DROPDOWN_SEARCH_INPUT: 'usersDropdownSearchInput',
  USERS_DROPDOWN_SEARCH_ICON: 'usersDropdownSearchIcon',
  USERS_DROPDOWN_MENU_ITEM: 'usersDropdownMenuItem',
  USERS_DROPDOWN_TAG: 'usersDropdownTag',
  USERS_DROPDOWN_AVATAR: 'usersDropdownAvatar',
  USERS_DROPDOWN_TICK_ICON: 'usersDropdownTickIcon',
  USERS_MULTI_DROPDOWN_POPOVER: 'usersMultiDropdownPopover',
  USERS_MULTI_DROPDOWN_SEARCH_INPUT: 'usersMultiDropdownSearchInput',
  USERS_MULTI_DROPDOWN_SEARCH_ICON: 'usersMultiDropdownSearchIcon',
  USERS_MULTI_DROPDOWN_MENU_ITEM: 'usersMultiDropdownMenuItem',
  USERS_MULTI_DROPDOWN_TAG: 'usersMultiDropdownTag',
  USERS_MULTI_DROPDOWN_SWITCH_BUTTON: 'usersMultiDropdownSwitchButton',
  USERS_MULTI_DROPDOWN_NO_RESULTS: 'usersMultiDropdownNoResults',
  VARIANCE_CODES_DROPDOWN_POPOVER: 'varianceCodesDropdownPopover',
  VARIANCE_CODES_DROPDOWN_SEARCH_INPUT: 'varianceCodesDropdownSearchInput',
  VARIANCE_CODES_DROPDOWN_SEARCH_ICON: 'varianceCodesDropdownSearchIcon',
  VARIANCE_CODES_DROPDOWN_MENU_ITEM: 'varianceCodesDropdownMenuItem',
  VARIANCE_CODES_DROPDOWN_PILL: 'varianceCodesDropdownPill',
  VARIANCE_CODES_DROPDOWN_TICK_ICON: 'varianceCodesDropdownTickIcon',
  VARIANCE_CODES_INPUT_CONTAINER: 'varianceCodesInputContainer',
  VARIANCE_CODES_INPUT_PLACEHOLDER: 'varianceCodesInputPlaceholder',
  VARIANCE_CODES_INPUT_PILL: 'varianceCodesInputPill',
  VARIANCE_CODES_INPUT_PILL_STRIKETHROUGH: 'varianceCodesInputPillStrikethrough',
  VARIANCE_CODES_INPUT_ARROW_ICON: 'varianceCodesInputArrowIcon',
  VARIANCE_CODES_MULTI_DROPDOWN_POPOVER: 'varianceCodesMultiDropdownPopover',
  VARIANCE_CODES_MULTI_DROPDOWN_SEARCH_INPUT: 'varianceCodesMultiDropdownSearchInput',
  VARIANCE_CODES_MULTI_DROPDOWN_SEARCH_ICON: 'varianceCodesMultiDropdownSearchIcon',
  VARIANCE_CODES_MULTI_DROPDOWN_MENU_ITEM: 'varianceCodesMultiDropdownMenuItem',
  VARIANCE_CODES_MULTI_DROPDOWN_PILL: 'varianceCodesMultiDropdownPill',
  VARIANCE_CODES_MULTI_DROPDOWN_SWITCH_BUTTON: 'varianceCodesMultiDropdownSwitchButton',
  VARIANCE_CODES_MULTI_DROPDOWN_NO_RESULTS: 'varianceCodesMultiDropdownNoResults',
  VARIANCE_CODES_MULTI_INPUT_CONTAINER: 'varianceCodesMultiInputContainer',
  VARIANCE_CODES_MULTI_INPUT_PLACEHOLDER: 'varianceCodesMultiInputPlaceholder',
  VARIANCE_CODES_MULTI_INPUT_PILLS: 'varianceCodesMultiInputPills',
  VARIANCE_CODES_MULTI_INPUT_ARROW_ICON: 'varianceCodesMultiInputArrowIcon',

  // Version Filter specific components
  VERSION_FILTER_WIDGET_SWITCH: 'versionFilterWidgetSwitch',
  VERSION_FILTER_WIDGET_SWITCH_WRAPPER: 'versionFilterWidgetSwitchWrapper',
  VERSION_FILTER_WIDGET_SWITCH_TEXT: 'versionFilterWidgetSwitchText',
  VERSION_FILTER_WIDGET_COMBINATOR_BUTTON: 'versionFilterWidgetCombinatorButton',
  VERSION_FILTER_WIDGET_ADD_CONDITION: 'versionFilterWidgetAddCondition',
  VERSION_FILTER_WIDGET_DELETE_ALL_CONDITIONS: 'versionFilterWidgetDeleteAllConditions',
  VERSION_FILTER_BUTTON: 'versionFilterButton',
  VERSION_FILTER_BUTTON_ICON: 'versionFilterButtonIcon',
  VERSION_FILTER_BUTTON_TEXT: 'versionFilterButtonText',
  VERSION_FILTER_CONDITION_EMPTY_FIELD_BUTTON: 'versionFilterConditionEmptyFieldButton',
  VERSION_FILTER_CONDITION_FIELD_BUTTON: 'versionFilterConditionFieldButton',
  VERSION_FILTER_CONDITION_FIELD_ICON: 'versionFilterConditionFieldIcon',
  VERSION_FILTER_CONDITION_FIELD_LABEL: 'versionFilterConditionFieldLabel',
  VERSION_FILTER_CONDITION_FIELD_ARROW: 'versionFilterConditionFieldArrow',
  VERSION_FILTER_CONDITION_OPERATOR_BUTTON: 'versionFilterConditionOperatorButton',
  VERSION_FILTER_CONDITION_OPERATOR_LABEL: 'versionFilterConditionOperatorLabel',
  VERSION_FILTER_CONDITION_OPERATOR_ARROW: 'versionFilterConditionOperatorArrow',
  VERSION_FILTER_CONDITION_DATE_PICKER: 'versionFilterConditionDatePicker',
  VERSION_FILTER_CONDITION_DATE_INPUT: 'versionFilterConditionDateInput',
  VERSION_FILTER_CONDITION_NAME_INPUT: 'versionFilterConditionNameInput',
  VERSION_FILTER_CONDITION_CHECKBOX_INPUT: 'versionFilterConditionCheckboxInput',
  VERSION_FILTER_CONDITION_CHECKBOX_LABEL: 'versionFilterConditionCheckboxLabel',
  VERSION_FILTER_CONDITION_DELETE_BUTTON: 'versionFilterConditionDeleteButton',
  VERSION_CODE_MULTI_DROPDOWN_SEARCH_INPUT: 'versionCodeMultiDropdownSearchInput',
  VERSION_CODE_MULTI_DROPDOWN_SEARCH_ICON: 'versionCodeMultiDropdownSearchIcon',
  VERSION_CODE_MULTI_DROPDOWN_MENU_ITEM: 'versionCodeMultiDropdownMenuItem',
  VERSION_CODE_MULTI_DROPDOWN_TAG: 'versionCodeMultiDropdownTag',
  VERSION_CODE_MULTI_DROPDOWN_SWITCH: 'versionCodeMultiDropdownSwitch',
  VERSION_CODE_MULTI_INPUT_CONTAINER: 'versionCodeMultiInputContainer',
  VERSION_CODE_MULTI_INPUT_TAGS: 'versionCodeMultiInputTags',
  VERSION_CODE_MULTI_INPUT_TAG: 'versionCodeMultiInputTag',
  VERSION_CODE_MULTI_INPUT_LABEL: 'versionCodeMultiInputLabel',
  VERSION_CODE_MULTI_INPUT_ARROW: 'versionCodeMultiInputArrow',
  VERSION_COMMIT_STATUS_DROPDOWN_SEARCH_INPUT: 'versionCommitStatusDropdownSearchInput',
  VERSION_COMMIT_STATUS_DROPDOWN_SEARCH_ICON: 'versionCommitStatusDropdownSearchIcon',
  VERSION_COMMIT_STATUS_DROPDOWN_MENU_ITEM: 'versionCommitStatusDropdownMenuItem',
  VERSION_COMMIT_STATUS_INPUT_CONTAINER: 'versionCommitStatusInputContainer',
  VERSION_COMMIT_STATUS_INPUT_LABEL: 'versionCommitStatusInputLabel',
  VERSION_COMMIT_STATUS_INPUT_ARROW: 'versionCommitStatusInputArrow',
  VERSION_COMMIT_STATUS_MULTI_DROPDOWN_SEARCH_INPUT: 'versionCommitStatusMultiDropdownSearchInput',
  VERSION_COMMIT_STATUS_MULTI_DROPDOWN_SEARCH_ICON: 'versionCommitStatusMultiDropdownSearchIcon',
  VERSION_COMMIT_STATUS_MULTI_DROPDOWN_MENU_ITEM: 'versionCommitStatusMultiDropdownMenuItem',
  VERSION_COMMIT_STATUS_MULTI_DROPDOWN_TAG: 'versionCommitStatusMultiDropdownTag',
  VERSION_COMMIT_STATUS_MULTI_DROPDOWN_SWITCH: 'versionCommitStatusMultiDropdownSwitch',
  VERSION_COMMIT_STATUS_MULTI_INPUT_CONTAINER: 'versionCommitStatusMultiInputContainer',
  VERSION_COMMIT_STATUS_MULTI_INPUT_TAGS: 'versionCommitStatusMultiInputTags',
  VERSION_COMMIT_STATUS_MULTI_INPUT_TAG: 'versionCommitStatusMultiInputTag',
  VERSION_COMMIT_STATUS_MULTI_INPUT_LABEL: 'versionCommitStatusMultiInputLabel',
  VERSION_COMMIT_STATUS_MULTI_INPUT_ARROW: 'versionCommitStatusMultiInputArrow',
  VERSION_CODE_DROPDOWN_SEARCH_INPUT: 'versionCodeDropdownSearchInput',
  VERSION_CODE_DROPDOWN_SEARCH_ICON: 'versionCodeDropdownSearchIcon',
  VERSION_CODE_DROPDOWN_MENU_ITEM: 'versionCodeDropdownMenuItem',
  VERSION_CODE_DROPDOWN_TAG: 'versionCodeDropdownTag',
  VERSION_CODE_INPUT_CONTAINER: 'versionCodeInputContainer',
  VERSION_CODE_INPUT_LABEL: 'versionCodeInputLabel',
  VERSION_CODE_INPUT_ARROW: 'versionCodeInputArrow'
} as const;
